import React, { Component, PropTypes } from "react";

import ChartBar from "../../../components/charts/chart-bar/ChartBar";
import ChartPie from "../../../components/charts/chart-bar/ChartPieAdv";
import ChartUtilisation from "../../../components/charts/chart-bar/ChartUtilisation";
import ChartScatterPlot from "../../../components/charts/chart-bar/ChartScatterPlot";
import DriverSafetySummary from "../../../components/charts/chart-bar/DriverSafetySummary";

import ChartHeatMap from "../../../components/charts/chart-bar/ChartHeatMap";
import ChartSummarySpline from '@src/components/charts/chart-bar/ChartSummarySpline';
import ChartSummaryDisplay from '@src/components/charts/chart-bar/ChartSummaryDisplay';

import DriverSafetyDetailedView from "./driverSafety/DriverSafetyDetailedView";

import { NitroLoading, NitroContentNotAvailable } from "nitro-components";
import { createSelector } from "reselect";

import { transformScatterPlot } from "../DataTransformer";
import ShowError from "../show-error";

const getScatterGraphDataSelector = state => state.data;

const getTransformedScatterData = createSelector(
  getScatterGraphDataSelector,
  transformScatterPlot // last argument is the function that has our select logic -- in our case its pretty simple logic of extracting props.
);

class InsightChart extends Component {
  export = options => {
    this.chart.export(options);
  };

  exportDocument = (svg, options) => {
    this.props.exportDocument(svg, options);
  };

  render() {
    const { error, data, insideDrawer, plotOptions } = this.props;
    // console.log({ error, data, insideDrawer, plotOptions });
    const { ChartType } = data ? data : {};

    // if received data: {error} from getData callback
    // then display error message
    if (error) return <ShowError />;

    let chart;

    switch (ChartType) {
      case "chartPie":
        chart = (
          <ChartPie
            ref={ref => (this.chart = ref)}
            data={data}
            plotOptions={plotOptions}
            exportDocument={this.exportDocument}
          />
        );
        break;
      case "chartUtilisation":
        chart = (
          <ChartUtilisation
            ref={ref => (this.chart = ref)}
            data={data}
            plotOptions={plotOptions}
            exportDocument={this.exportDocument}
          />
        );
        break;
      case "chartDriverSafetySummary":
        chart = (
          <DriverSafetySummary ref={ref => (this.chart = ref)} data={data} />
        );
        break;
      case "chartDriverSafetyDetailedView":
        chart = null;
        break;
      case "chartScatterPlot": {
        const transformedData = transformScatterPlot(data);
        chart = (
          <ChartScatterPlot
            ref={ref => (this.chart = ref)}
            data={transformedData}
            plotOptions={plotOptions}
            exportDocument={this.exportDocument}
          />
        );
        break;
      }
      case "chartHeatMap":
      case "chartHeatMapSummary": {
        chart = (
          <ChartHeatMap
            ref={ref => (this.chart = ref)}
            data={data}
            plotOptions={plotOptions}
            exportDocument={this.exportDocument}
            insideDrawer={insideDrawer}
          />
        );
        break;
      }
      case "chartSummarySpline": {
        chart = (
          <ChartSummarySpline
            ref={ref => (this.chart = ref)}
            metadata={this.props.metadata}
            data={data}
          />
        )
        break;
      }
      case 'chartSummaryDisplay':{
        chart = (
          <ChartSummaryDisplay
            ref={ref => (this.chart = ref)}
            metadata={this.props.metadata}
            data={data}
          />
        )
        break;
      }
      default:
        chart = (
          <ChartBar
            ref={ref => (this.chart = ref)}
            data={data}
            plotOptions={plotOptions}
            exportDocument={this.exportDocument}
          />
        );
    }

    if ( this.props.graphLoading )
      return <NitroLoading center />;

    return Object.keys(data).length > 0 ? chart : <NitroContentNotAvailable />;
  }
}

InsightChart.propTypes = {
  data: PropTypes.object.isRequired,
  plotOptions: PropTypes.object,
  exportDocument: PropTypes.func,
  insideDrawer: PropTypes.bool,
  metadata: PropTypes.object,
  graphLoading: PropTypes.bool,
};

export default InsightChart;



// WEBPACK FOOTER //
// ./src/features/insights/components/InsightChart.js